// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__F1Ae0","row":"ProcedureTreatmentSummary_row__x91tX"};